import { render, staticRenderFns } from "./GlobalCopyBadge.vue?vue&type=template&id=1d95db00"
import script from "./GlobalCopyBadge.vue?vue&type=script&lang=js"
export * from "./GlobalCopyBadge.vue?vue&type=script&lang=js"
import style0 from "./GlobalCopyBadge.vue?vue&type=style&index=0&id=1d95db00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports